/**
 * @file Vercel preview-deployment origin matcher. Preview deploys use dynamic subdomains like oath-<hash>-<team> and oath-git-<branch>-<team>.
 * Isolated module (no React/env imports) so edge functions can import it without pulling in the full environment config.
 */
export const VERCEL_PREVIEW_ORIGIN_RE = /^https:\/\/oath-[a-z0-9-]+\.vercel\.app$/;
